// Pure rollout-gate decision for native browser video compression, kept separate from
// VideoDropTarget.tsx (a React/JSX file that cannot be imported in this project's Vitest/jsdom
// setup — see vitest.setup.js) so the fail-closed logic itself is directly unit-testable.
// Deliberately has no LaunchDarkly import: the LaunchDarkly SDK is only ever touched in
// VideoDropTarget.tsx's wrapper component, which evaluates the `nativeBrowserVideoCompression`
// flag via useFlags() and passes the raw value in here.

// Whether native browser video compression should be attempted, given the raw evaluated value
// of the `nativeBrowserVideoCompression` LaunchDarkly flag (React SDK property name for the
// `native-browser-video-compression` flag key). Fails closed to the existing external-compressor
// flow for anything other than an explicit `true` — false, undefined, a missing flag, or
// LaunchDarkly not yet initialized all disable native compression. LaunchDarkly itself owns
// targeting and rollout percentage; this function only ever sees the already-evaluated boolean.
export function isNativeBrowserVideoCompressionEnabled(flagValue: unknown): boolean {
    return flagValue === true
}
